import { render, staticRenderFns } from "./VitrineWizard.vue?vue&type=template&id=2855d1a6&"
import script from "./VitrineWizard.vue?vue&type=script&lang=js&"
export * from "./VitrineWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports